import React from "react";
import {
  Box,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  Chip
} from "@material-ui/core";

const ValidationErrorList = ({ errors = [] }) => {
  const uploadedFieldMap = {
    email: "Email",
    employee_id: "Employee ID",
    first_name: "First Name",
    last_name: "Last Name",
    gender: "Gender",
    branch: "Office Location",
    withdrawal_percent: "Withdrawal Percent",
    "bank.account_holder": "Account holder name",
    "bank.name": "Bank Name",
    "bank.code": "Bank Code",
    "bank.number": "Account number",
    "bank.iban": "IBAN(optional)",
    "profile.position": "Title",
    "profile.phone": "Phone number",
    "profile.salary": "Full Net Salary",
    "profile.savings": "Savings",
    "profile.nin": "NIN",
    "profile.bvn": "BVN",
  };

  const toReadableLabel = (key) =>
    key
      .replace(/\./g, " ")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

  const getDisplayFieldName = (fullKey) =>
    uploadedFieldMap[fullKey] || uploadedFieldMap[fullKey?.toLowerCase()] || toReadableLabel(fullKey);

  if (!errors || errors.length === 0) {
    return (
      <Box p={2}>
        <Typography variant="body1" style={{ color: "green" }}>
          No validation errors
        </Typography>
      </Box>
    );
  }

  // Check if errors is an array of strings
  const isStringArray = errors.length > 0 && typeof errors[0] === "string";

  const renderFieldErrors = (field, value, parentKey = "") => {
    const fullKey = parentKey ? `${parentKey}.${field}` : field;

    if (Array.isArray(value)) {
      return (
        <Box key={fullKey} mt={2}>
          <Typography
            variant="subtitle2"
            style={{ fontWeight: 600 }}
          >
            {getDisplayFieldName(fullKey)}
          </Typography>

          {value.map((msg, idx) => (
            <ListItem key={`${fullKey}-${idx}`} style={{ paddingLeft: 16 }}>
              <ListItemText
                primary={msg}
                primaryTypographyProps={{
                  color: "error",
                  variant: "body2"
                }}
              />
            </ListItem>
          ))}
        </Box>
      );
    }

    if (value && typeof value === "object") {
      return Object.entries(value).map(([nestedField, nestedValue]) =>
        renderFieldErrors(nestedField, nestedValue, fullKey)
      );
    }

    return (
      <Box key={fullKey} mt={2}>
        <Typography
          variant="subtitle2"
          style={{ fontWeight: 600 }}
        >
          {getDisplayFieldName(fullKey)}
        </Typography>
        <ListItem style={{ paddingLeft: 16 }}>
          <ListItemText
            primary={value}
            primaryTypographyProps={{
              color: "error",
              variant: "body2"
            }}
          />
        </ListItem>
      </Box>
    );
  };

  if (isStringArray) {
    return (
      <Box style={{ maxHeight: "inherit", overflowY: "scroll" }}>
        <List dense>
          {errors.map((error, index) => (
            <ListItem key={index} style={{ paddingLeft: 16 }}>
              <ListItemText
                primary={error}
                primaryTypographyProps={{
                  color: "error",
                  variant: "body2"
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    );
  }

  return (
    <Box style={{ maxHeight: "inherit", overflowY: "scroll" }}>
      {errors.map((rowError, rowIndex) => {
        if (Object.keys(rowError).length <= 0) return null;
        return (<Paper
          key={rowIndex}
          elevation={2}
          style={{
            marginBottom: 16,
            padding: 16,
            borderLeft: "6px solid #f44336"
          }}
        >
          {/* Row Header */}
          <Box display="flex" alignItems="center" mb={2}>
            <Chip
              label={`Row ${rowIndex + 1}`}
              color="secondary"
              size="small"
              style={{ marginRight: 8 }}
            />
            <Typography variant="h6">
              Validation Errors
            </Typography>
          </Box>

          <Divider />

          {/* Fields */}
          <List dense>
            {Object.entries(rowError).map(([field, value]) =>
              renderFieldErrors(field, value)
            )}
          </List>
        </Paper>)
      })}
    </Box>
  );
};

export default ValidationErrorList;